export const MenuItems = [
  {
    id: "admin-dashboard",
    moduleName: "Dashboard",
    orderNo: 1,
    url: "/dashboard",
    roles: ["Admin", "SuperAdmin"],
  },
  {
    id: "exams",
    moduleName: "Exams",
    orderNo: 2,
    url: "/exams",
    roles: ["Admin", "SuperAdmin"],
  },
  {
    id: "generate",
    moduleName: "Generate",
    orderNo: 3,
    roles: ["Admin", "SuperAdmin"],
    subMenu: [
      {
        id: "generate-reports",
        moduleName: "Generate Reports",
        orderNo: 1,
        url: "/generate-report",
        roles: ["Admin", "SuperAdmin"],
      },
      {
        id: "generate-workstations",
        moduleName: "Generate Workstations",
        orderNo: 2,
        url: "/generate-workstation",
        roles: ["Admin", "SuperAdmin"],
      },
    ],
  },

  // Examiner
  {
    id: "examiner-dashboard",
    moduleName: "Dashboard",
    orderNo: 1,
    url: "/examiner-dashboard",
    roles: ["Examiner", "HeadExaminer"],
  },
  {
    id: "examination",
    moduleName: "Examination",
    orderNo: 2,
    url: "/questions",
    roles: ["Examiner"],
  },

  // Head Examiner
  {
    id: "mapping",
    moduleName: "Mapping",
    orderNo: 2,
    roles: ["HeadExaminer"],
    subMenu: [
      {
        id: "set-mapping",
        moduleName: "Optional Question Mapping",
        orderNo: 1,
        url: "/he-set",
        roles: ["HeadExaminer"],
      },
      {
        id: "group-mapping",
        moduleName: "Examiners",
        orderNo: 2,
        url: "/examiner-group",
        roles: ["HeadExaminer"],
      },
    ],
  },
  {
    id: "evaluation",
    moduleName: "Evaluation",
    orderNo: 3,
    roles: ["HeadExaminer"],
    subMenu: [
      {
        id: "evaluations",
        moduleName: "Evaluations",
        orderNo: 1,
        url: "/examiners",
        roles: ["HeadExaminer"],
      },
      {
        id: "moderation",
        moduleName: "Moderation",
        orderNo: 2,
        url: "/he-moderation",
        roles: ["HeadExaminer"],
      },
    ],
  },
];
